<template>
  <div class='changelocale'>
    <!-- <select v-model="$i18n.locale" v-on:change="toggle()">
      <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang" >{{ lang }}</option>
    </select> -->

    <b-btn @click="switchLocale(otherlocale)" variant="link" :style="[!open ? 'color: black':'color: white; padding-left: 0px;']">{{otherlocale}}</b-btn>    
  </div>
</template>

<script>
import { store, mutations } from '@/store/store.js'

export default {
  name: 'changelocale',
  data () {
    return { 
      langs: ['en', 'fr'] 
      }
  },
  methods: {
      toggle() {
        if (this.open == true) {
            mutations.toggleNav()
        }
        
  },
  switchLocale(locale) {
        if (this.$i18n.locale !== locale) {
          this.$i18n.locale = locale;
        }
      }  
  },
  computed: {
    otherlocale(){
      if(this.$i18n.locale === 'en'){
          return 'fr'
      }
      else{
        return 'en'
      }
      
    },
    open () {
      return store.isNavOpen
      }
  }
}
</script>
<style scoped>
/* .changelocale {
    height: 3vh;
} */
select {
   border:0px;
   outline:0px;
}
</style>


// WEBPACK FOOTER //
// src/components/buttons/ChangeLocale.vue